module.exports = __webpack_public_path__ + "static/media/goldenboy-toilet.1520f154.gif";